import { getCurrentOrLegacyReportsByEntityId } from '@opengov/reporting-legacy-module';

import { composeEffects } from '../../module';
import { currentOrLegacyReportActionCreators } from '../state';

export const currentOrLegacyReportEffects = composeEffects('report', (compose) => ({
  loadCurrentAndLegacyReports: compose.effect(
    async (e: { entityId: number; includeAccountSummaryReports?: boolean; includeMultiDatasetReports?: boolean }) => {
      currentOrLegacyReportActionCreators.loadReports();

      return getCurrentOrLegacyReportsByEntityId({
        entityId: e.entityId,
        includeAccountSummaryReports: e.includeAccountSummaryReports,
        includeMultiDatasetReports: e.includeMultiDatasetReports
      })
        .then((mergedReports) => {
          currentOrLegacyReportActionCreators.loadReportsSuccess(mergedReports);
          return mergedReports;
        })
        .catch(currentOrLegacyReportActionCreators.loadReportsError);
    }
  )
}));
